import findAllDayItemRow from './findAllDayItemRow';
import SurfaceDragHelperBase from './SurfaceDragHelperBase';
import { addSurfaceBox } from '../../Templates';
import { DragDropHelperProps } from './DragDropHelperProps';
import { getAllowedResizeTypesForAllDayItem } from '../../calculation/getAllowedResizeTypes';
import { observer } from 'mobx-react';
import { trace } from 'owa-trace';
import { transformAllDayItem } from 'owa-calendar-surface-dategrid/lib/transformers/transformAllDayItem';
import {
    CalendarSurfaceTransformProps,
    createSurfaceItemFromModel,
    DragOperationType,
    DroppableType,
    SurfaceItem,
} from 'owa-calendar-surface-dategrid';

/**
 * Props for the all-day drag helper
 */
export interface AllDayDragHelperProps extends DragDropHelperProps {
    allDayRows: SurfaceItem[][];
    config: CalendarSurfaceTransformProps;
}

/**
 * All-day drag helper component
 */
@observer
export default class AllDayDragHelper extends SurfaceDragHelperBase<AllDayDragHelperProps, any> {
    private rowIndex: number = -1;

    protected get droppableType(): DroppableType {
        return DroppableType.AllDay;
    }

    protected onNotDragging = () => {
        this.rowIndex = -1;
    };

    protected getUnfoldedHelpers = () => {
        let { surfaceStore, config } = this.props;
        let { dragDropState } = surfaceStore;

        this.ensureRowIndex();

        let item = createSurfaceItemFromModel(
            dragDropState.helperItemModel.ItemId.Id + '_allDayDragHelper',
            dragDropState.helperItemModel,
            config.columnProvider
        );

        // During drag-and-drop there was a case where we would get no visible intervals
        // on the new week; it happened when dragging items across the DST-change week.
        if (item) {
            let gridItem = transformAllDayItem(
                surfaceStore,
                config.columnProvider,
                config.getItemConfig(item.model),
                item,
                this.rowIndex
            );

            let gridDraggableItem = gridItem;

            // If resizing, add drag drop grippers to the new item
            if (surfaceStore.dragDropState.dragType != DragOperationType.Drag) {
                let allowedResizeTypes = getAllowedResizeTypesForAllDayItem(
                    surfaceStore,
                    config.dragDropConfig,
                    item.model
                );

                let colorScheme = config.dragDropConfig.colorProvider?.(item.model);
                gridDraggableItem = addSurfaceBox(
                    surfaceStore,
                    item,
                    gridItem,
                    allowedResizeTypes,
                    colorScheme
                );
            }

            return [gridDraggableItem];
        }

        return null;
    };

    private ensureRowIndex = () => {
        if (this.rowIndex < 0) {
            this.rowIndex = findAllDayItemRow(
                this.props.surfaceStore.dragDropState.draggedItemModel,
                this.props.allDayRows
            );
            if (this.rowIndex < 0) {
                trace.warn(
                    'AllDayDragHelper: Failed to find row index for dragged item during drag and drop, assuming index 0'
                );
                this.rowIndex = 0;
            }
        }
    };
}
